import React, { Component } from "react";
import {
  Container, Row, Col, Card, CardHeader, CardBody,
  Button, ButtonGroup, ButtonToolbar, CardImg,
} from "reactstrap";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';
import { bindActionCreators } from "redux";

import LoadingIcon from 'mdi-react/LoadingIcon';
import SettingsIcon from 'mdi-react/SettingsIcon';

import DeletePopUP from "../../../shared/components/deletePopUp";
import * as BackIcon from "../../../assets/back-icon.png";

import {
  loadCollections,
  createOrUpdateCollection,
  deleteCollection,
  openCollection
} from "../../../redux/actions/collections";

class Collections extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCollection:null,
      formType: null,
      dataLoaded: false,
      showDeleteAlert: false
    };

     this.openForm = this.openForm.bind(this);
  }


  componentWillMount() {
    console.log("Mounting collections component");
    this.props.loadCollections();
  }

  componentWillReceiveProps (nextProps){
        console.log("Received Props for collections");
        console.log(nextProps);
        if (nextProps.collections){
            this.setState ({ dataLoaded:true,  formType: null,  showDeleteAlert: false, selectedCollection:null});
        }
  }



  openForm = (type, selectedCollection) => {
        console.log("Collection openForm");
        console.log(selectedCollection);
        if (selectedCollection){
                selectedCollection["formType"]= type;
                this.props.openCollection(selectedCollection);
        } else{
                this.props.openCollection(null);
        }
        this.props.history.push("/settings/create_update_collection");
  };


  renderActionButtons = (cell, row) => {
    return (
      <div className="text-center">
        <ButtonToolbar>
          <ButtonGroup className="btn-group--icons" dir="ltr">
            <Button outline color="success" onClick={() => {this.openForm("update", row);}}><span className="lnr lnr-pencil" /></Button>
            <Button outline color="warning"  onClick={() => {this.openForm("clone", row);}}><span className="lnr lnr-plus-circle" /></Button>
            <Button outline color="danger" onClick={() => {this.setState({ showDeleteAlert: true, selectedCollection: row });}}><span className="lnr lnr-cross" /></Button>
          </ButtonGroup>
        </ButtonToolbar>
      </div>
    );
  }

  renderActionButton2 = props => {
    return (
        <div className="text-right">
           <Button className="icon" color="primary" onClick={() => this.openForm("create")}><p><SettingsIcon /> New Collection</p></Button>
        </div>
    );
  }


  renderCollections() {
    const options = {
      searchPosition: 'left',
      btnGroup: this.renderActionButton2
    };
    return (
      <Card>
        <CardHeader>
          Facilities
        </CardHeader>
        <CardBody>
          <BootstrapTable
            options={options}
            data={this.props.collections}
            version="4"
            bordered={false}
            striped pagination search
          >
            <TableHeaderColumn dataField="collection_name" dataSort>
              Name
            </TableHeaderColumn>
            <TableHeaderColumn width="160" dataField="collection_type">
              Type
            </TableHeaderColumn>
            <TableHeaderColumn width="140" dataField="industry">
              Industry
            </TableHeaderColumn>
            <TableHeaderColumn width="140" dataField="global_industry_code">
              Industry Code
            </TableHeaderColumn>
            <TableHeaderColumn width="160" dataField="location">
              Location
            </TableHeaderColumn>
            <TableHeaderColumn isKey dataField="_id" dataSort hidden={true}>
              Id
            </TableHeaderColumn>
            <TableHeaderColumn width="160" dataField="_id" dataFormat={this.renderActionButtons}>Actions</TableHeaderColumn>

          </BootstrapTable>
        </CardBody>
      </Card>
    );
  }


  render() {
    const { t } = this.props;
    return (
      <Container>
          {this.state.dataLoaded ?

           <Row>
                <Col md={12}>
                    <h3 className="page-title">{t('collection_settings.title')}</h3>
                    <h3 className="page-subhead subhead">A facility represents a factory, plant, facility, or a data center. It's grouping of assets or processes either by location or data management.
                    </h3>
                 {this.renderCollections()}
                </Col>
            </Row>
          : ""}

          { !this.state.dataLoaded ?
             <Row>
               <Card>
                    <CardHeader>
                      <div className="form__form-group-icon">
                          <LoadingIcon />
                      </div>
                      Loading Information about Facilities
                    </CardHeader>
                    <CardBody>
                      <div></div>
                    </CardBody>
               </Card>
             </Row>
           : ""}

            <DeletePopUP
              title="Are you sure, you want to delete this Collection?"
              showDeleteAlert={this.state.showDeleteAlert}
              onDelete={() => {
                this.setState({ showDeleteAlert: false });
                this.props.deleteCollection(this.state.selectedCollection);
              }}
              onCancel={() => {
                this.setState({ showDeleteAlert: false });
              }}
            />
      </Container>
    );
  }
}

function mapStateToProps({ collections }) {
  console.log("collections state changed");
  return {
    collections
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      loadCollections,
      deleteCollection,
      createOrUpdateCollection,
      openCollection
    },
    dispatch
  );
}

export default withTranslation('common') (connect(mapStateToProps,mapDispatchToProps)(Collections));
